import axiosBase from "axios";
import { myConst } from "@/config/";

const axios = axiosBase.create({
    baseURL: myConst.API_URL,
    timeout: 10 * 1000,
});

axios.interceptors.request.use((config) => {
    document.querySelector("#progress").classList.add('show');
    return config;
}, (error) => {
    return Promise.reject(error);
});
//配置请求回来的信息
axios.interceptors.response.use((response) => {
    document.querySelector("#progress").classList.remove("show");
    return response;
}, (error) => {
    document.querySelector("#progress").classList.remove("show");
    return Promise.reject(error);
});



export const getStreetList = () => {
    return axios.get('/ParkingMap/streetList.json');
};

export const getStreetDetail = (param) => {
    return axios.post("/ParkingMap/streetDetail.json", param);
};


export const getParkingList = () => {
    return axios.get('/ParkingMap/parking.json');
};


export const getOilList = () => {
    return axios.get('/ParkingMap/oilList.json');
};

export const getNewEnergyList = () => {
    return axios.get('/ParkingMap/newEnergyList.json');
};

export const record = (data) => {
    return axios.post('/ParkingMap/record.json', data);
};

export const feedback = (data) => {
    const f = axiosBase.create({
        baseURL: myConst.API_URL.replace("parking", ''),
        timeout: 10 * 1000,
    });

    return f.post("/feedback", data);
};


export const getWcList = () => {
    const f = axiosBase.create({
        baseURL: myConst.API_URL.replace("parking", 'wc'),
        timeout: 10 * 1000,
    });
    return f.get("/list.json");
};
